package amazon.lastmile.inject

import app.nestbridge.feature.children.presentation.ChildrenPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ChildrenPresenterFactory::class)
public interface AppNestbridgeFeatureChildrenPresentationChildrenPresenterFactory {
  @Provides
  @IntoSet
  public fun provideChildrenPresenterFactoryFactoryMultibinding(childrenPresenterFactory: ChildrenPresenterFactory): Presenter.Factory = childrenPresenterFactory
}
